module.exports = __webpack_public_path__ + "img/img_slogan.183556ae.svg";